import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Button,
  Card,
  Checkbox,
  Form,
  Modal,
  Result,
  Select,
  Tag,
  Empty,
  message,
  Input,
} from "antd";
import { Col, Row } from "react-bootstrap";
import Slots from "../../../config/timeSlots.json";
import Defult from "../../settingScreen/meetingMail/defult.json";
import TimeSlots from "./timeSlots";
import { GENERATE_SLOTS } from "../helpers/generateSlots";
import { GET, POST } from "../../../utils/apiCalls";
import API from "../../../config/api";
import { COMBINE_SLOTS } from "../helpers/combineSlots";
import StartupItem from "./startupItem";
import ReactQuill from "react-quill";
import EmailContent from "../helpers/mailTemplate";
import NoImage from "../../../assets/images/noimage.jpg";
import { FrownOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
function Meetings(props: any) {
  const [form] = Form.useForm(); // Initialize Ant Design Form
  const [loading, setLoading] = useState(true);
  const Events = useSelector((state: any) => state.Events);
  const User = useSelector((state: any) => state.User?.user);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const [checkedSlot, setCheckedSlot] = useState<any>(null);
  const [slots, setSlots] = useState([]);
  const [meetings, setMeetings] = useState<any>([]);
  const [counts, setCounts] = useState({ total: 0, assigned: 0 });
  const [roomData, setRoomData] = useState<any>([]);
  const [sendMail, setSendMail] = useState(false);
  const [sendIcs, setSendIcs] = useState(true);
  const [sendMailcc, setSendMailcc] = useState(true);
  const [defultMail, setDefultMail] = useState<any>(Defult);
  const [mailTemplate, setMailTemplate] = useState(false);
  const [mailData, setMailData] = useState<any>(null);
  const [meetingRoom, setMeetingRoom] = useState<any>(props?.data?.meeting_room);
  const [showUnassignModal, setShowUnassignModal] = useState(false);

  const showSlot = (value: any) => {
    let slot = Slots?.filter((i: any) => i.value === value);
    return slot[0]?.label;
  };

  useEffect(() => {
    loadData();
    getMail();
    getMeetingRooms();
  }, []);

  const getMail = async () => {
    try {
      let api = API?.MAIL_TEMPLATE_LIST + `${Events?.defult?.id}`;
      const params = { type: 'meeting' };
      const response: any = await GET(api, params);
      if (response?.status && response?.data?.length) {
        setDefultMail(response?.data[0]);
      }
    } catch (err) {
      console.error("Error fetching mail template:", err);
    }
  };

  const loadData = async () => {
    try {
      let url =
        API.INVESTORS_DETAILS +
        props?.data?.uuid +
        `?eventId=${Events?.defult?.id}`;
      const res: any = await GET(url, null);
      if (res.status) {
        createSlots(
          res.data?.data?.timeSlots,
          30,
          "13-14",
          res?.data?.meetings
        );
      } else {
        message.error("Something went wrong...!");
      }
    } catch (err) {
      console.error("Error loading data:", err);
    } finally {
      setLoading(false);
    }
  };

  const createSlots = async (
    slots: any,
    period: any,
    exclusions: any,
    meetings: any
  ) => {
    try {
      let slotData: any = await GENERATE_SLOTS(slots, period, exclusions);
      let combine: any = await COMBINE_SLOTS(slotData, meetings);
      setSlots(combine);
      setCounts({ total: slotData.length, assigned: meetings.length });
    } catch (err) {
      console.error("Error creating slots:", err);
    }
  };

  const checkMeetings = async (slot: any) => {
    try {
      setCheckedSlot(slot);
      setLoading2(true);
      if (slot?.startups?.id) {
        setMeetings([slot?.startups]);
      } else {
        let url = API.STARTUPS_FREESLOT + `${Events?.defult?.id}/` + slot?.slot;
        const response: any = await GET(url, null);
        if (response.status) {
          const filteredStartups = response?.data?.filter(
            (startup: any) =>
              !slots?.some(
                (meeting: any) => meeting?.startup_id === startup?.id
              )
          );
          setMeetings(filteredStartups);
        } else {
          setMeetings([]);
        }
      }
    } catch (err) {
      console.error("Error checking meetings:", err);
    } finally {
      setLoading2(false);
    }
  };

  const selectStartups = (item: any, method: any) => {
    try {
      setLoading2(true);
      const slotso: any = [...slots];
      let findIndex = slotso.findIndex((i: any) => i?.slot === checkedSlot?.slot);
      if (findIndex >= 0) {
        let obj = slotso[findIndex];
        if (method === "add") {
          obj = {
            id: null,
            uuid: null,
            slot: checkedSlot?.slot,
            investor_name: props?.data?.fullname,
            startup_name: item?.name,
            status: true,
            investor_id: props?.data?.id,
            startup_id: item?.id,
            createdAt: null,
            updatedAt: null,
            room: null,
            startups: {
              id: item?.id,
              logo: item?.logo,
              name: item?.name,
              country: item?.country,
              category: item?.category,
            },
          };
        } else {
          obj = {
            id: null,
            uuid: null,
            slot: checkedSlot?.slot,
            investor_name: null,
            startup_name: null,
            status: false,
            investor_id: null,
            startup_id: null,
            createdAt: null,
            updatedAt: null,
            room: null,
            startups: {
              id: null,
              logo: item?.logo,
              name: item?.name,
              country: item?.country,
              category: item?.category,
            },
          };
          checkMeetings(checkedSlot);
        }
        slotso[findIndex] = obj;
        setSlots(slotso);
        setMeetings([obj?.startups]);
        setCheckedSlot(checkedSlot);
      }
    } catch (err) {
      console.error("Error selecting startups:", err);
    } finally {
      setLoading2(false);
    }
  };
  const processHtml = (html: string) => {
    let updated = html;

    // 1️⃣ Normalize all <p> tags to tight spacing (email safe)
    updated = updated
      .replace(/<p>/g, '<p style="margin: 0 0 6px 0; padding: 0; line-height: 1.3;">')
      .replace(
        /<p style="[^"]*">/g,
        '<p style="margin: 0 0 6px 0; padding: 0; line-height: 1.3;">'
      );

    // 2️⃣ Replace Quill's empty <p><br></p> with a tiny safe spacer
    updated = updated.replace(
      /<p><br><\/p>/g,
      '<p style="margin: 3px 0;"></p>'
    );

    // 3️⃣ Replace <br/> with small controlled gap (<span> is Quill-safe)
    updated = updated.replace(
      /<br\s*\/?>/g,
      '<span style="display: block; height: 4px;"></span>'
    );

    // 4️⃣ Remove extra multiple blank spacers (cleanup)
    updated = updated.replace(
      /(<span style="display: block; height: 4px;"><\/span>\s*){2,}/g,
      '<span style="display: block; height: 4px;"></span>'
    );

    return updated;
  };
  const emailEditor = async () => {
    try {
      let obj = {
        user: props?.data,
        meetings: slots,
        eventId: Events?.defult?.id,
        location: Events?.defult?.location,
        event_date: Events?.defult?.event_date,
        room: meetingRoom,
        content: defultMail?.content,
      };
      let replacedContent = await EmailContent(obj);
      setMailData(replacedContent);
      setMailTemplate(true);
    } catch (err) {
      console.error("Error generating email content:", err);
    }
  };
 
  const submit = async () => {
    try {
      setLoading3(true);
      // Validate form and get values
      const formValues = await form.validateFields();
      const cleanedCc = Array.isArray(formValues?.cc)
        ? formValues.cc
            .map((e: string) => e.trim())
            .filter((e: string) => e.length > 0)
        : [];

      // Use the edited content from ReactQuill
      // Backend will replace ${InvestorName} placeholder with appropriate name for each recipient
      let contentToSend = mailData || '';

      let vc = {
        ...props?.data,
        date: Events?.defult?.event_date
          ? dayjs(Events?.defult?.event_date).format("DD-MM-YYYY")
          : "",
        timeSlots: props?.data?.timeSlots,
        prodId: "corporateconnect.hub71.com",
        id: props?.data?.eventId,
        profileId: props?.data?.id,
        domain: "corporateconnect.hub71.com",
        organizerName: "Corporate Connect",
        organizerEmail: "donotreply@corporateconnect.hub71.com",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        summary: Events?.defult?.name || "Corporate Connect",
        location: Events?.defult?.location,
        description: Events?.defult?.description,
      };
      let obj = {
        id: props?.data?.id,
        vc: vc,
        slots: slots,
        sendMail: sendMail,
        mailData: mailData,
        to: formValues?.to || props?.data?.email,
        ccMails: cleanedCc,
        subject: formValues?.subject || defultMail?.subject,
        contect: processHtml(contentToSend),
        sendIcs: sendIcs,
        sendMailcc: sendMailcc,
        eventId: Events?.defult?.id,
        link: `${API.WEB_URL}/vc-details/${props?.data?.uuid}?event=${Events?.defult?.id}`,
        created_by: User?.name,
      };

      let response: any = await POST(API.MEETING_BULK_CREATE, obj);
      if (response?.status) {
        message.success("Meetings scheduled successfully");
        loadData();
        props.onClose();
      } else {
        message.error("Something went wrong...!");
      }
    } catch (err) {
      console.error("Error submitting meetings:", err);
      message.error("Something went wrong...!");
    } finally {
      setLoading3(false);
    }
  };

  const updateRoom = async (room: any) => {
    try {
      setLoading4(true);
      let obj = {
        id: props?.data?.id,
        room_id: room,
        room: roomData.find((item: any) => item.id === room)?.name,
        eventId: Events?.defult?.id,
      };

      let response: any = await POST(API.INVESTORS_SET_ROOM, obj);
      if (response?.status) {
        message.success("Room assigned successfully");
        setMeetingRoom(room);
        loadData();
      } else {
        message.error(response?.message);
      }
    } catch (err) {
      console.error("Error updating room:", err);
      message.error("Something went wrong...!");
    } finally {
      setLoading4(false);
    }
  };

  const handleUnassignRoom = async () => {
    try {
      setLoading4(true);
      let obj = {
        id: props?.data?.id,
        room_id: null,
        room: null,
        eventId: Events?.defult?.id,
      };

      let response: any = await POST(API.INVESTORS_SET_ROOM, obj);
      if (response?.status) {
        message.success("Room unassigned successfully");
        setMeetingRoom(null);
        loadData(); // Refresh data to reflect changes
      } else {
        message.error("Something went wrong...!");
      }
    } catch (err) {
      console.error("Error unassigning room:", err);
      message.error("Something went wrong...!");
    } finally {
      setLoading4(false);
      setShowUnassignModal(false);
    }
  };

  const getMeetingRooms = async () => {
    try {
      setLoading2(true);
      let url = API.ROOMS_PICKER + Events?.defult?.id;
      const response: any = await GET(url, null);
      if (response?.status) {
        setRoomData(response?.data);
      } else {
        setRoomData([]);
      }
    } catch (err) {
      console.error("Error fetching meeting rooms:", err);
    } finally {
      setLoading2(false);
    }
  };

  return (
    <Modal
      title={"Schedule Meetings"}
      open={props.visible}
      onCancel={() => props.onClose()}
      footer={false}
      centered
      closable={!loading3}
      maskClosable={!loading3}
      width={900}
    >
      <div className="investorScreen-Meetings">
        <div className="investorScreen-Box">
          <div>
            <img
              src={props?.data?.logo || NoImage}
              style={{ width: 100, height: 70, objectFit: "contain" }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <div className="investorScreen-text1">{props?.data?.company}</div>
            <div className="investorScreen-text2">{props?.data?.fullname}</div>
            <div className="investorScreen-text2">{props?.data?.jobTitle}</div>
          </div>
          <div className="investorScreen-Box2">
            <Tag style={{ width: 170 }}>{showSlot(props?.data?.timeSlots)}</Tag>
            <div>
              Meeting Room :{" "}
              <Select
                showSearch
                style={{ width: 170, marginRight: 8 }}
                placeholder="Select Room"
                onChange={(value: any) => {
                  Modal.confirm({
                    title: 'Assign Room',
                    content: `Are you sure you want to assign this room?`,
                    onOk() {
                      updateRoom(value);
                    },
                    onCancel() {
                      // Reset the select value to previous state
                      setShowUnassignModal(false);
                    },
                  });
                }}
                loading={loading4}
                value={meetingRoom}
                optionFilterProp="children"
              >
                {roomData?.map((item: any) => (
                  <Select.Option key={item?.id} value={item?.id}>
                    {item?.name}
                  </Select.Option>
                ))}
              </Select>
              {meetingRoom && (
                <Button
                  type="primary"
                  style={{ marginLeft: 8 }}
                  onClick={() => setShowUnassignModal(true)}
                >
                  Unassign Room
                </Button>
              )}
            </div>
          </div>
        </div>
        <br />
        <Form form={form}>
          {mailTemplate ? (
            <>
                       {mailTemplate && sendMail && (
              <>
              <div className="label">To</div>
                <Form.Item
                  name="to"
                  initialValue={props?.data?.email}
                  rules={[
                    { required: true, message: "Recipient email is required" },
                    { type: "email", message: "Enter a valid email address" },
                  ]}
                >
                  <Input size="large" placeholder="To" />
                </Form.Item>
                <div className="label">CC</div>
                <Form.Item
                  name="cc"
                  initialValue={API.CC_MAIL}
                  rules={[
                    {
                      validator: async (_, value) => {
                        if (!value || value.length === 0) return Promise.resolve();
                        const isBasicEmail = (raw: string) => {
                          const v = (raw || "").trim();
                          if (!v) return false;
                          if (/\s/.test(v)) return false;
                          const at = v.indexOf("@");
                          const dot = v.lastIndexOf(".");
                          return at > 0 && dot > at + 1 && dot < v.length - 1;
                        };
                        const isValid = (value as string[]).every((v) =>
                          isBasicEmail(v)
                        );
                        return isValid
                          ? Promise.resolve()
                          : Promise.reject(
                              new Error("Enter valid CC emails (e.g., name@domain.com)")
                            );
                      },
                    },
                  ]}
                >
                  <Select
                    mode="tags"
                    size="large"
                    placeholder="CC"
                    allowClear
                    showSearch
                    tokenSeparators={[",", ";", " "]}
                    options={(API.CC_MAIL || []).map((e: string) => ({
                      label: e,
                      value: e,
                    }))}
                  />
                </Form.Item>
                <div className="label">Subject</div>
                <Form.Item name = "subject" initialValue={defultMail?.subject ? defultMail?.subject : ""}>
                <Input size="large" placeholder="Subject" />
                </Form.Item>
              </>
            )}
            <Form.Item>
              <ReactQuill
                style={{ height: 300 }}
                theme="snow"
                value={mailData}
                onChange={setMailData}
              />
            </Form.Item>
            <br />
            <div style={{ margin: 10 }} />
            <Row>
              <Col sm={6}><span className="pillStyle">Investor Name: ${"{InvestorName}"}</span></Col>
              <Col sm={3}>
                <Form.Item
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                  }}
                >
                  <Checkbox
                    disabled={loading3}
                    checked={sendMailcc}
                    onChange={(value: any) =>
                      setSendMailcc(value?.target?.checked)
                    }
                  >
                    Send To Attendees
                  </Checkbox>
                </Form.Item>
              </Col>
              <Col sm={3}>
                <Form.Item
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                  }}
                >
                  <Checkbox
                    disabled={loading3}
                    checked={sendIcs}
                    onChange={(value: any) =>
                      setSendIcs(value?.target?.checked)
                    }
                  >
                    Attach .ics
                  </Checkbox>
                </Form.Item>
              </Col>
            </Row>
          </>
        ) : (
          <Row style={{ marginBottom: 20 }}>
            <Col sm={6}>
              <Card
                size="small"
                title={"Slots"}
                extra={slots?.length}
                loading={loading}
              >
                <div className="investorScreen-scrollBox">
                  {slots?.length
                    ? slots.map((item: any, index: any) => (
                          <TimeSlots
                            key={index}
                            item={item}
                            checked={checkedSlot}
                            onChange={(value: any) => checkMeetings(value)}
                          />
                        ))
                    : null}
                </div>
              </Card>
            </Col>
            <Col sm={6}>
              <Card
                size="small"
                title={"Startups"}
                loading={loading2}
                extra={meetings?.length}
              >
                <div className="investorScreen-scrollBox">
                  {meetings?.length ? (
                    meetings?.map((item: any, index: any) => (
                        <StartupItem
                          key={index}
                          item={item}
                          checked={slots.filter(
                            (i: any) =>
                              i?.startups?.id === item?.id &&
                              i?.slot === checkedSlot?.slot
                          )}
                          onChange={(value: any) =>
                            selectStartups(value, "add")
                          }
                          remove={(value: any) =>
                            selectStartups(value, "remove")
                          }
                        />
                      ))
                  ) : (
                    <div className="investorScreen-text5">
                      {checkedSlot ? (
                        <Empty description={"No startup available"} />
                      ) : (
                        "Select a time slot"
                      )}
                    </div>
                  )}
                </div>
              </Card>
            </Col>
          </Row>
        )}
        <Row>
          <Col sm={6}>
            <Checkbox
              disabled={loading3}
              onChange={(value: any) => {
                setSendMail(value?.target?.checked);
                if (!value?.target?.checked) {
                  setMailTemplate(false);
                }
              }}
            >
              Send Mail Notification
            </Checkbox>
          </Col>

          <Col sm={3}>
            <Button
              size="large"
              block
              danger
              disabled={loading3}
              onClick={() => props.onClose()}
            >
              Close
            </Button>
          </Col>
          <Col sm={3}>
            <Button
              size="large"
              type="primary"
              block
              loading={loading3}
              onClick={() =>
                sendMail ? (mailTemplate ? submit() : emailEditor()) : submit()
              }
            >
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
      </div>
      
      <Modal
        title="Unassign Room"
        open={showUnassignModal}
        onOk={handleUnassignRoom}
        onCancel={() => setShowUnassignModal(false)}
        okText="Unassign"
        cancelText="Cancel"
      >
        <p>Are you sure you want to unassign the current room?</p>
      </Modal>
    </Modal>
  );
}

export default Meetings;